// extracted by mini-css-extract-plugin
export default {"itemWrapper":"eventsCard_itemWrapper__xujV5","imgWrapper":"eventsCard_imgWrapper__tc6TU","textWrapper":"eventsCard_textWrapper__gfOyj","viewMore":"eventsCard_viewMore__la0O7"};